import { render, staticRenderFns } from "./SupplementReview.vue?vue&type=template&id=388b94e1&"
import script from "./SupplementReview.vue?vue&type=script&lang=js&"
export * from "./SupplementReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports